import { createTheme } from '../theme';
const theme = createTheme({
  components: {
    MuiContainer: {
      defaultProps: {
        disableGutters: true,
        maxWidth: false,
      },
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx } }) =>
          sx({
            py: 4,
            px: 3,
            m: 'auto',
            maxWidth: 1440,
            minHeight: '100%',
          }),
      },
    },
  },
});

export default theme.components;
